<template>
  <v-row class="mt-1">
    <v-col>
      <ValidationObserver ref="lotForm" v-slot="{ invalid, validated }">
        <v-expansion-panels multiple>
          <v-expansion-panel v-test="{ panel: '' }">
            <ValidationObserver ref="info" v-slot="{ failed }">
              <v-expansion-panel-header>
                <div id="info">
                  <v-icon>
                    info
                  </v-icon>
                  {{ $t('Общая информация') }}
                  <v-icon v-if="failed" color="error">
                    warning
                  </v-icon>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <v-row>
                  <v-col
                      cols="12"
                      md="6"
                      class="pl-2 pt-0">
                    <validatable-text-input
                        v-model="lot.lotDescription"
                        :readonly="readonly"
                        rules="required"
                        :label="$t('Предмет договора')" />
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                      class="pl-2">
                    <validatable-date-picker
                        v-model="lot.publicationDate"
                        v-test="{ date: 'publicationDate' }"
                        rules="required"
                        dense
                        :label="$t('Дата публикации')" />
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                      class="pl-2">
                    <validatable-enum-combobox
                        v-model="lot.premiumType"
                        :values-enum="PREMIUM_TYPE_ENUM"
                        rules="required"
                        dense
                        :readonly="readonly"
                        :clearable="!readonly"
                        :label="$t('Способ расчета цены')" />
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                      class="pl-2 pr-4 py-0">
                    <validatable-text-input
                        v-if="isFixPremium"
                        v-model="lot.currency"
                        readonly
                        rules="required"
                        :label="$t('Валюта Договора')" />
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                      class="pl-2 pr-4 py-0">
                    <validatable-organizer-selection
                        v-model="lot.creatorId"
                        rules="required"
                        :readonly="readonly"
                        :label="$t('Пользователь организатора')"
                        @change="onCreatorChanged" />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </ValidationObserver>
          </v-expansion-panel>

          <v-expansion-panel v-test="{ panel: '' }">
            <ValidationObserver ref="contacts" v-slot="{ failed }">
              <v-expansion-panel-header>
                <div id="contact_mail">
                  <v-icon>
                    contact_mail
                  </v-icon>
                  {{ $t('Контактная информация') }}
                  <v-icon v-if="failed" color="error">
                    warning
                  </v-icon>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <v-row>
                  <v-col
                      cols="12"
                      md="6"
                      class="pl-2">
                    <validatable-text-input
                        v-model="lot.contactPerson"
                        v-test="{ input: 'contactPerson' }"
                        :readonly="readonly || !isUserLoaded"
                        prepend-icon="person"
                        rules="required"
                        dense
                        :label="$t('Контактное лицо')" />
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                      class="pl-2">
                    <validatable-text-input
                        v-model="lot.contactPhone"
                        v-test="{ input: 'contactPhone' }"
                        dense
                        :readonly="readonly || !isUserLoaded"
                        :rules="{ required: true,
                                  regex: /^[+]?[\d\s(\-);,]+$/ }"
                        :label="$t('Контактный телефон')"
                        prepend-icon="settings_phone"
                        :type="'tel'" />
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                      class="pl-2">
                    <validatable-text-input
                        v-model="lot.contactEmail"
                        v-test="{ input: 'contactEmail' }"
                        dense
                        :readonly="readonly || !isUserLoaded"
                        rules="required|email"
                        :label="$t('Электронный адрес')"
                        prepend-icon="alternate_email" />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </ValidationObserver>
          </v-expansion-panel>

          <v-expansion-panel v-test="{ panel: '' }">
            <ValidationObserver ref="client" v-slot="{ failed }">
              <v-expansion-panel-header>
                <div id="contact_mail">
                  <v-icon>
                    contact_mail
                  </v-icon>
                  {{ $t('Признак принадлежности заявки') }}
                  <v-icon v-if="failed" color="error">
                    warning
                  </v-icon>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <v-row>
                  <v-col
                      cols="12"
                      md="12"
                      class="pl-2">
                    <validatable-checkbox
                        :value="isClient"
                        :label="$t('Клиентская')"
                        @change="setIsClient" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                      cols="12"
                      md="6"
                      class="pl-2">
                    <validatable-text-input
                        v-if="isClient"
                        v-model="lot.clientOrganizationInn"
                        v-test="{ input: 'clientOrganizationInn' }"
                        :readonly="readonly || !isUserLoaded"
                        rules="required"
                        dense
                        :label="$t('ИНН организации Клиента')" />
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                      class="pl-2">
                    <validatable-text-input
                        v-if="isClient"
                        v-model="lot.clientOrganizationFullName"
                        v-test="{ input: 'clientOrganizationFullName' }"
                        rules="required"
                        dense
                        :readonly="readonly || !isUserLoaded"
                        :label="$t('Полное наименование организации Клиента')" />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </ValidationObserver>
          </v-expansion-panel>

        </v-expansion-panels>
        <v-alert
            class="text-center"
            :value="invalid && validated"
            type="error">
          {{ $t('Не все поля заполнены.') }}
        </v-alert>
      </ValidationObserver>
    </v-col>
  </v-row>
</template>

<script>
  import Vue from 'vue'
  import ValidatableDatePicker from '@/components/reused/ui/ValidatableDatePicker.vue'
  import ValidatableEnumCombobox from '@/components/reused/ui/ValidatableEnumCombobox.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableOrganizerSelection from '../ui/ValidatableOrganizerSelection.vue'
  import ValidatableCheckbox from '@/components/reused/ui/ValidatableCheckbox.vue'

  import {
    LOT_TYPE_ENUM,
    LOT_STATUS_TYPE_ENUM,
    PREMIUM_TYPE_ENUM
  } from '@/constants/enums'
  import { LOT_STATUSES, DICTIONARY_TYPES, PREMIUM_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { USER_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      ValidatableDatePicker,
      ValidatableTextInput,
      ValidatableEnumCombobox,
      ValidatableOrganizerSelection,
      ValidatableCheckbox
    },
    props: {
      readonly: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      saveMethod: {
        type: Function
      },
      lotInfo: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        LOT_TYPE_ENUM,
        DICTIONARY_TYPES,
        LOT_STATUS_TYPE_ENUM,
        PREMIUM_TYPE_ENUM,
        PREMIUM_TYPES,
        lot: {
          creatorId: null,
          lotDescription: null,
          publicationDate: null,
          premiumType: PREMIUM_TYPES.FIX,
          currency: 'Рубль РФ',
          contactPerson: null,
          contactPhone: null,
          contactEmail: null,
          clientOrganizationInn: null,
          clientOrganizationFullName: null
        },
        lastTimerId: null,
        isClient: false
      }
    },
    computed: {
      ...mapState(USER_MANAGEMENT.NAMESPACE, {
        organizerUser: state => (state[USER_MANAGEMENT.STATE.CURRENT_USER] || {})
      }),
      hasChanges () {
        return Object.keys(this.lot).some(key => {
          if (key === 'creatorId') {
            return this.isAdmin
              ? this.lot.creatorId !== this.lotInfo.creatorId
              : false
          }
          return this.lot[key] !== this.lotInfo[key]
        })
      },
      isFixPremium () {
        return this.lot.premiumType === PREMIUM_TYPES.FIX
      },
      isUserLoaded () {
        return !!this.organizerUser.contactPerson
      },
      canEditField () {
        return !this.readonly &&
          (!this.lotInfo.lotStatus || this.lotInfo.lotStatus === LOT_STATUSES.DRAFT)
      }
    },
    watch: {
      lotInfo: {
        deep: true,
        immediate: true,
        handler: function (newVal) {
          this.mapFields(newVal)
          this.isClient = !!newVal?.clientOrganizationInn || !!newVal?.clientOrganizationFullName
        }
      }
    },
    beforeDestroy () {
      this.clearStore()
      if (this.lastTimerId) {
        clearTimeout(this.lastTimerId)
        this.lastTimerId = null
      }
    },
    created () {
      this.clearStore()
    },
    methods: {
      ...mapActions(USER_MANAGEMENT.NAMESPACE, {
        getUserForAdminAction: USER_MANAGEMENT.ACTIONS.GET_USER_FOR_ADMIN,
        clearUserForAdminAction: USER_MANAGEMENT.ACTIONS.CLEAR_USER_FOR_ADMIN
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearUserForAdminAction()
          ])
      },
      validateAndSave: async function () {
        const result = await this.$refs.lotForm.validate()
        if (!result) {
          throw new Vue.errorsTypes.ValidationError()
        }
        // если изменений нет, то сохранение не нужно
        if (this.readonly || !this.hasChanges) {
          return
        }
        if (this.saveMethod) {
          await this.saveMethod(this.lot)
        }
      },
      onCreatorChanged: async function (userId) {
        if (this.readonly || !this.isAdmin || !userId) {
          return
        }

        try {
          await this.getUserInfo(userId)

          this.setContactPersonInfo(this.organizerUser)
          this.lot.creatorId = this.organizerUser.userId
        } catch (error) {
          this.throwIfNotServerError(error)
        }
      },
      getUserInfo: async function (userId) {
        await this.clearUserForAdminAction()
        await this.getUserForAdminAction({
          userId
        })
      },
      setContactPersonInfo: async function (info) {
        const vm = this
        let timeout = 1
        if (!info.contactPerson) {
          timeout = 1500
        }

        if (vm.lastTimerId) {
          clearTimeout(vm.lastTimerId)
          vm.lastTimerId = null
        }

        vm.lastTimerId = setTimeout((info1) => {
          if (!info1.contactPerson) { return }
          vm.lot.contactPerson = info1.contactPerson || null
          vm.lot.contactPhone = info1.phone || info1.contactPhone || null
          vm.lot.contactEmail = info1.email || info1.contactEmail || null
        }, timeout, info)
      },
      setIsClient: function (val) {
        if (!val) {
          this.lot.clientOrganizationInn = null
          this.lot.clientOrganizationFullName = null
        } else {
          this.lot.clientOrganizationInn = this.lotInfo.clientOrganizationInn
          this.lot.clientOrganizationFullName = this.lotInfo.clientOrganizationFullName
        }
        this.isClient = val
      },
      mapFields: async function (lot) {
        try {
          this.isLoading = true
          if (this.isAdmin) {
            if (!lot.lotId) {
              return
            }

            if (lot.creatorId) {
              this.lot.creatorId = lot.creatorId

              await this.getUserInfo(lot.creatorId)
            }
          }

          const organizerUser = lot.lotId
            ? lot
            : this.organizerUser

          await this.setContactPersonInfo(organizerUser)
          if (lot.publicationDate) {
            this.lot.publicationDate = lot.publicationDate
          }
          if (!lot.lotId) {
            return
          }

          if (!lot.currency) {
            lot.currency = 'Рубль РФ'
          }
          for (const key in this.lot) {
            if (this.lot[key] !== lot[key]) {
              this.lot[key] = lot[key]
            }
          }
        } catch (error) {
          this.throwIfNotServerError(error)
        } finally {
          this.isLoading = false
        }
      }
    }
  }
</script>
